
<template>
  <div>
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />
    <Dialog
      :title="'Are you sure you want to delete this item?'"
      :text="'This action is not reversible.'"
      :rejectButtonText="'No'"
      :acceptButtonText="'Yes'"
      :toggle="dialog"
      @reject="dialog = false"
      @accept="confirmDeleteItem"
    />
    <div>
      <v-row>
        <v-col cols="12" md="6" class="pt-0">
          <div class="header text-left">Manage Announcements</div>
        </v-col>
        <v-col cols="12" md="6" class="action-buttons pt-0">
          <v-btn class="filter-btn" color="#FDBB30">Filter</v-btn>
          <v-btn
            class="create-btn"
            color="#00457C"
            @click="navCreateAnnouncement"
            >Create Announcement</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="error">
        <v-col cols="12">
          <v-alert type="error">Error occurred. Please try again.</v-alert>
        </v-col>
      </v-row>

      <!-- Table -->
      <TableComponent
        type="announcements"
        v-bind:dynamicHeaders="dynamicHeaders"
        v-bind:dynamicWidths="dynamicWidths"
        v-bind:dynamicRowsDetail="dynamicRowsDetail"
        v-on:view-item="viewAnnouncement"
        v-on:delete-item="openDeleteDialog"
        v-on:view-item-analytics="viewAnalytics"
      />
      <!-- <v-data-table
        :headers="dynamicHeaders"
        :items="dynamicRowsDetail"
        :items-per-page="10"
        class="elevation-1"
      >
      </v-data-table> -->
    </div>

    <!-- Dialog View -->
    <div
      v-if="currentAccouncementView !== null"
      class="dialog-ann-wrapper dialog-screen-wrapper"
    >
      <div class="content">
        <div class="close-section">
          <span class="close-btn" v-on:click="closeAnnouncementDialog"
            >Close</span
          >
        </div>
        <v-img
          alt="announcement image"
          class="image-section"
          contain
          :src="currentAccouncementView.imgUrl"
          transition="scale-transition"
        />
        <div class="title-section">{{ currentAccouncementView.title }}</div>
        <div class="start-date-section">
          {{ getDisplayDate(currentAccouncementView.startDate) }}
        </div>
        <div
          class="desc-section"
          v-html="currentAccouncementView.content"
        ></div>
        <div
          class="action-section"
          v-if="currentAccouncementView.btnTitle !== ''"
        >
          <div
            v-on:click="openNewPage(currentAccouncementView.redirectUrl)"
            class="action-btn"
          >
            {{ currentAccouncementView.btnTitle }}
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog View -->
    <div
      v-if="currentAccouncementAnalytics !== null"
      class="dialog-ann-wrapper dialog-screen-wrapper"
    >
      <div class="content-analytics">
        <div class="close-section">
          <span class="close-btn" v-on:click="closeAnnouncementDialog"
            >Close</span
          >
        </div>
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>Unique users (Read):</h4>
            </v-col>
            <v-col>
              {{ currentAccouncementAnalytics.registeredTokens.length }}
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>Notification Title</h4>
            </v-col>
            <v-col>
              {{ currentAccouncementAnalytics.notif_title }}
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>Notification Content</h4>
            </v-col>
            <v-col>
              <div v-html="currentAccouncementAnalytics.notif_content"></div>
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>Inbox Title</h4>
            </v-col>
            <v-col>
              {{ currentAccouncementAnalytics.title }}
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>Topic</h4>
            </v-col>
            <v-col>
              {{ currentAccouncementAnalytics.topic }}
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>Start Date:</h4>
            </v-col>
            <v-col>
              {{ getDisplayDate(currentAccouncementAnalytics.startDate) }}
            </v-col>
          </v-row>
        </div>
        <hr />
        <div class="title-section-analytics">
          <v-row>
            <v-col>
              <h4>End Date:</h4>
            </v-col>
            <v-col>
              {{ getDisplayDate(currentAccouncementAnalytics.endDate) }}
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "./commons/TableComponent";
import moment from "moment";
import Axios from "axios";
import Dialog from "./commons/Dialog";
import LoadingScreen from "./commons/LoadingScreen";

export default {
  components: {
    TableComponent,
    Dialog,
    LoadingScreen,
  },
  data() {
    return {
      itemDeleteId: null,
      dialog: false,
      // dynamicHeaders: ["Title", "Topic", "Start Date", "End Date"],
      dynamicHeaders: [
        { text: "Title", value: "title" },
        { text: "Topic", value: "topic" },
        { text: "Start Date", value: "startDate" },
        { text: "End Date", value: "endDate" },
        { text: "Actions", value: "actions" },
      ],
      dynamicWidths: ["130px", "70px", "130px", "130px"],
      dynamicRowsDetail: [],
      rawAnnouncementDetails: [],
      currentAccouncementView: null,
      currentAccouncementAnalytics: null,
      loading: false,
      error: false,
      page: 1,
      startRow: 0,
      rowsPerPage: 10,
    };
  },
  created() {
    // Fetch all announcements
    Axios.get(
      process.env.VUE_APP_HOST_SERVER + "/api/announcements/get_all"
    ).then((res) => {
      console.log("Successfully retrieved all details");
      this.rawAnnouncementDetails = res.data;
      this.dynamicRowsDetail = this.processFetchedData(res.data);
    });
  },
  methods: {
    movePages: function (amount) {
      var newStartRow = this.startRow + amount * this.rowsPerPage;
      if (
        newStartRow >= 0 &&
        newStartRow < this.rawAnnouncementDetails.length
      ) {
        this.startRow = newStartRow;
      }
    },
    getDisplayDate(date) {
      if (date._seconds !== undefined) {
        return moment(new Date(date._seconds * 1000)).format("DD MMM YYYY");
      } else {
        return moment(date).format("DD MMM YYYY");
      }
    },
    processFetchedData(rawAnnouncementData) {
      return rawAnnouncementData.map(
        ({ _id, title, startDate, endDate, topic }) => {
          return {
            rowId: _id,
            title: title,
            topic: topic,
            startDate: this.getDisplayDate(startDate),
            endDate: this.getDisplayDate(endDate),
            action: { view: "show", delete: "show", analytics: "show" },
          };
        }
      );
    },
    navCreateAnnouncement() {
      this.$store.dispatch("loadView", "AddAnnouncements");
    },
    viewAnnouncement(id) {
      this.currentAccouncementView = this.rawAnnouncementDetails.find(
        (item) => item._id == id
      );
    },
    closeAnnouncementDialog() {
      this.currentAccouncementView = null;
      this.currentAccouncementAnalytics = null;
    },
    editAnnouncement(id) {
      this.$router
        .push({ name: "EditAnnouncements", params: { itemId: id } })
        .catch(() => {});
    },
    confirmDeleteItem() {
      this.loading = true; //enable loading screen once user clicks delete
      this.dialog = false;
      // Update MongoDB
      // Update MongoDB
      Axios.delete(
        process.env.VUE_APP_HOST_SERVER +
          `/api/announcements/delete/${this.itemDeleteId}`
      ).then((res) => {
        // Update client data and delete image from S3
        const imgUrlToDelete = this.rawAnnouncementDetails.find(
          (item) => item._id == this.itemDeleteId
        ).imgUrl;
        this.dynamicRowsDetail = this.dynamicRowsDetail.filter(
          (rowDetail) => rowDetail.rowId !== res.data._id
        );
        Axios.delete(process.env.VUE_APP_HOST_SERVER + "/api/file/delete", {
          data: { s3Url: imgUrlToDelete },
        })
          .then(() => {
            this.loading = false; //disable loading screen once request is handled
            this.error = false;
            this.$router.go();
          })
          .catch((err) => {
            console.log(err);
            this.error = true;
          });
        // alert("Announcement successfully deleted.");
      });
    },
    openDeleteDialog(id) {
      this.dialog = true;
      this.itemDeleteId = id;
    },
    openNewPage(redirectUrl) {
      window.open("http://" + redirectUrl);
    },
    viewAnalytics(id) {
      this.currentAccouncementAnalytics = this.rawAnnouncementDetails.find(
        (item) => item._id == id
      );
    },
  },
};
</script>

<style>
/* View Announcement Dialog */
.dialog-ann-wrapper .content {
  width: 400px;
  height: 800px;
  overflow: scroll;
  padding: 24px;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.dialog-ann-wrapper .content-analytics {
  width: 400px;
  height: 500px;
  overflow: scroll;
  padding: 24px;
  background-color: white;
  display: flex;
  flex-direction: column;
}

.dialog-ann-wrapper .close-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 10px;
}

.dialog-ann-wrapper .close-section .close-btn {
  cursor: pointer;
  color: #ea6254;
  font-size: 11px;
  font-weight: bold;
}

.dialog-ann-wrapper .image-section {
  width: 100%;
}

.dialog-ann-wrapper .title-section {
  padding-top: 15px;
  text-align: start;
  font-size: 15px;
  font-weight: bold;
}

.dialog-ann-wrapper .title-section-analytics {
  padding-top: 5px;
  text-align: start;
  font-size: 12px;
  font-weight: bold;
}

.dialog-ann-wrapper .start-date-section {
  text-align: start;
  font-size: 9px;
  padding-top: 0px;
  color: #9b9b9b;
  font-weight: bold;
}

.dialog-ann-wrapper .desc-section {
  text-align: start;
  padding-top: 10px;
  font-size: 9px;
  color: #9b9b9b;
  flex-grow: 1;
  width: 100%;
}

.dialog-ann-wrapper .action-section {
  flex-basis: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.dialog-ann-wrapper .action-btn {
  width: fit-content;
  font-size: 12px;
  padding: 5px 15px 5px 15px;
  background-color: #204281;
  color: white;
  border-radius: 20px;
  cursor: pointer;
}
</style>
